require('../../../vendor/assets/components/headroom.js/dist/headroom.min.js');
require('../../../vendor/assets/components/headroom.js/dist/jQuery.headroom.min.js');

LpHeadroom = LP.module 'LpHeadroom'
LpHeadroom.site = ->
  if Headroom.cutsTheMustard && !LP.config.disable_headroom
    $('#header-wrap').each ->
      $this = $(this)
      options = $.extend($this.data(),
        onPin: -> $this.trigger 'headroom.pinned'
        onUnpin: -> $this.trigger 'headroom.unpinned')

      $this.headroom(options)
